export function getSemiRandomPercent(min, max, percent, index) {
  if (index % 7 === 0) {
    return (0.7 + percent / 100) * 0.5 * max;
  }

  if (index % 5 === 0) {
    return (0.1 + percent / 100) * 0.5 * max;
  }

  if (index % 3 === 0) {
    return (0.9 + percent / 100) * 0.5 * max;
  }

  if (index % 2 === 0) {
    return (0.8 + percent / 100) * 0.5 * max;
  }

  return min;
}
